import IntlMessages from 'helpers/IntlMessages';
import React, { SetStateAction } from 'react';
import { Button } from 'react-bootstrap';

/** A button that is used to open available filters on a small screen (filters are collapsed by default) */
const CollapsibleFiltersButton = ({ isFiltersOpen, setIsFiltersOpen, className, setShowSearchField }
  : {
    className?: string,
    isFiltersOpen: boolean,
    setIsFiltersOpen: React.Dispatch<SetStateAction<boolean>>,
    setShowSearchField?: React.Dispatch<SetStateAction<boolean>>,
  }) => {

  return (
    <Button
      onClick={() => { setIsFiltersOpen(!isFiltersOpen); setShowSearchField && setShowSearchField(false) }}
      className={`float-right mb-1 btn btn-empty pr-2 ${className}`}
      aria-controls='filters-collapse'
      aria-expanded={isFiltersOpen}
    >
      <span className='text-normal'><IntlMessages id='general.filters' /></span>
      <i className='simple-icon-arrow-down align-middle ml-2' />
    </Button>
  );
};

export default CollapsibleFiltersButton;
